















import Vue from "vue";
import Component from "vue-class-component";
import {  Prop } from "vue-property-decorator";
import { TransportParty } from "../models";

@Component
export default class PlanTaskDialogLoadTask extends Vue {
    @Prop() party!: TransportParty | { city: string, zipCode: string };
    @Prop() customerAddress!: string | null;
}
